import React from 'react'

import { NextPage } from 'next'
import { campusSSRApi } from 'utils/api'

import KoinworksLP from 'components/containers/KoinworksLP'
import CampusSeo from 'components/utils/CampusSeo'

const Koinworks: NextPage<{ seo: LooseObj }> = ({ seo }) => (
  <div className="koinworks">
    <CampusSeo seo={seo} />
    <KoinworksLP />
  </div>
)

Koinworks.getInitialProps = async () => {
  const seoRespose = await campusSSRApi('api/seo?path=/koinworks')
  const seoJson = await seoRespose.json()

  return { seo: seoJson }
}

export default Koinworks
